import { Component } from '@angular/core';
import { FormComponentLookup } from '@ptl/forms';
import { MassUploadFormControlComponent } from '../mass-upload-form-control.component';
import { debounceTime, distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import { County, CountyListResponse } from '@ptl/global-components';
import { NormalizedResponse } from '@ptl/xhr';

@FormComponentLookup('mass-upload-grid-control-county')
@Component({
  selector: 'app-mass-upload-county-form-control',
  templateUrl: '../mass-upload-form-control.component.html',
  styleUrl: '../mass-upload-form-control.component.scss',
  standalone: false
})
export class MassUploadCountyFormControlComponent extends MassUploadFormControlComponent {
  
  ngOnInit() {
    super.ngOnInit();

    this.isDropdown = true;

    if (this.entry.formControlAttributes.setDefaultValue) {
      this.entry.formControlAttributes.setDefaultValue = this.entry.formControlAttributes.setDefaultValue.toUpperCase();
    }

    this.entry.formControlAttributes.validators.push({
      "type": "required",
      "value": true
    });
      
    /** When the ZIP CODE changes, update the county */
    let zipCodeControl = this.getZipCodeControl();
    this.subscriptionGroup.push(zipCodeControl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(zip => zip?.length === 5),
        tap(() => {
          this.isLoading = true;
        }),
        switchMap((zip) => this.mugService.fetchIndividualCounty(zip))
      )
      .subscribe((countyResponse) => {
        this.isLoading = false;

        this.updateCounty(countyResponse);
      })
    );
  }

  async updateCounty(countyResponse: NormalizedResponse<CountyListResponse>) {
    this.dropdownOptions = [];

    if (countyResponse?.payload?.countyList?.length) {
      let countyOptions = countyResponse.payload.countyList.map((county: County) => {
        return {label: county.county, value: county.county.toUpperCase()}
      });

      this.dropdownOptions = [{label:'', value: null}].concat(countyOptions);
    }

    // Check to see if the county string name matches a real county. If it doesn't, we reset the form value to null
    let realCounty = await this.getCounty();
    if (realCounty) {
      return;
    }
    
    this.resetFormValue(null);
  }
}
